import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import ThemeToggle from './ThemeToggle';
interface LoginScreenProps {
  onLogin: () => void;
}
const LoginScreen: React.FC<LoginScreenProps> = ({
  onLogin
}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, you would validate credentials here
    onLogin();
  };
  return <div className="min-h-screen bg-blue-50 dark:bg-gray-900 flex flex-col justify-center px-6 py-12" data-id="element-169">
      <div className="absolute top-4 right-4" data-id="element-170">
        <ThemeToggle data-id="element-171" />
      </div>
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-172">
        <div className="flex justify-center" data-id="element-173">
          <img src="https://via.placeholder.com/180x180?text=BG+Logo" alt="Burhani Guards International Logo" className="h-28 w-auto" data-id="element-174" />
        </div>
        <h2 className="mt-6 text-center text-2xl font-bold leading-9 text-gray-900 dark:text-white" data-id="element-175">
          Burhani Guards International
        </h2>
        <p className="text-center text-sm text-gray-600 dark:text-gray-400 mt-1" data-id="element-176">
          Dahod Member Portal
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-177">
        <div className="bg-white dark:bg-gray-800 px-6 py-8 shadow rounded-lg" data-id="element-178">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-179">
            <div data-id="element-180">
              <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-200" data-id="element-181">
                ITS Number / Username
              </label>
              <div className="mt-2" data-id="element-182">
                <input id="username" name="username" type="text" required value={username} onChange={e => setUsername(e.target.value)} className="block w-full rounded-md border-0 py-3 px-4 text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-blue-600 dark:focus:ring-blue-500 dark:bg-gray-700" data-id="element-183" />
              </div>
            </div>
            <div data-id="element-184">
              <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-200" data-id="element-185">
                Password
              </label>
              <div className="mt-2 relative" data-id="element-186">
                <input id="password" name="password" type={showPassword ? 'text' : 'password'} required value={password} onChange={e => setPassword(e.target.value)} className="block w-full rounded-md border-0 py-3 px-4 text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-blue-600 dark:focus:ring-blue-500 dark:bg-gray-700" data-id="element-187" />
                <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-188">
                  {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-500 dark:text-gray-400" data-id="element-189" /> : <EyeIcon className="h-5 w-5 text-gray-500 dark:text-gray-400" data-id="element-190" />}
                </button>
              </div>
            </div>
            <div className="flex items-center justify-end" data-id="element-191">
              <div className="text-sm" data-id="element-192">
                <a href="#" className="font-medium text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-193">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div data-id="element-194">
              <button type="submit" className="flex w-full justify-center rounded-md bg-blue-600 px-3 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 dark:bg-blue-700 dark:hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600" data-id="element-195">
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
};
export default LoginScreen;